<template>
    <div class="fullcontainer p3_2bg">
      <Back2FirstPage picposcls="picpos" />
      <MusicIcon picposcls="musicpos" />

      <div class="centerdiv">
        <img class="bg" src="res/p3/rn.png?1">

         <video v-show="state==0" ref="video" class="video" :src="`res/video/2rn.mp4${qver}`" :poster="`res/video/2rn.jpg${qver}`" preload @pause="onPause" @play="onPlay" webkit-playsinline playsinline controls>
          您的浏览器不支持 video 标签。
        </video>

        <div class="AnimatePlayerDiv" @touchmove="onTouchMove">
            <AnimatePlayer v-show="state==1"  animateKey="rndaiji" />
            <AnimatePlayer v-show="state==2"  animateKey="rn" />
            <AnimatePlayer class="hand" v-show="state==1"  animateKey="rnhand" />
        </div>

        <img v-show="state!=0" class="gs" src="res/p3/gs.png">

        <img class="leftbtn heartpulse" src="res/p3/ksp.png" @click="watchVideo">
        <img class="rightbtn" src="res/p3/xiyb.png" @click="$root.$emit('P3SwitchTo','P3_4')">
      </div>

    </div> 
</template>

<script>
import { qver } from "@/d";
import Back2FirstPage from "./Back2FirstPage";
import MusicIcon,{getExtends} from "./MusicIcon";
import AnimatePlayer from "./AnimatePlayer";

const components = { Back2FirstPage, MusicIcon, AnimatePlayer };
export default {
  data() {
    return {
      // testurl: url("res/gz.png"),
      state : 1, // 0 视频 1 待机 2 搓揉
      qver
    };
  },

  mounted() {
    // window.console.log("mounted。。。");
    // this.$refs.video.play();
  },

  methods: {
    onClick() {
      // this.testinfo = "a";
      // this.$root.$emit("SwitchTo", "PageStack");
    },
    watchVideo(){
      this.state = 0;
      let video = this.$refs.video;
      video.play();
    },
    onTouchMove(){
      if(0==this.state) return;
      if(2==this.state) return;
      // clearTimeout(this.timeid);
      // this.timeid = setTimeout(() => {
      //   this.state = 1;
      // }, 800);
      this.state = 2;
    },
  },

  components,
  extends: getExtends()
};
</script>

<style lang="scss">
@import "D:/workspace/all_web/src/_cmm/css/centerbg.scss";
@import "D:/workspace/all_web/src/_cmm/css/horizontalCenterPercent.scss";

.p3_2bg {
  // @include centerbg; //'res/p1/bg.png'
  // background: url("../../public/res/p1/bg.png");

  // $top:
  .AnimatePlayerDiv {
    // background-color: rebeccapurple;
    top:2.5rem;
    height: 3.5rem;
    
    position: absolute;
    @include horizontalCenterPercent(72%);
    .xyr {
      @include horizontalCenterPercent(72%);
      top: 0rem;
    }
    .hand.xyr  {
      width: 60%;
      left: 1rem;
      top: 1.8rem;
    }
  }

  .gs {
     @include horizontalCenterPercent(60%);
     top:6.5rem;
  }
  
}
</style>
